// What the shell shows for which world. AUDIT-2026-09-23 U3.
//
// THE SIMULATOR LEAKED INTO A REAL LEAGUE'S SHELL: the top bar carried the
// sim clock ("Everything on screen is computed from this clock", with Play
// and Jump to Sunday night) on every real-league screen and on the hub, and
// the chat chip opened the simulator's feed. `useAwards` had already been
// gated for exactly this reason on 2026-09-22; the shell had not. Pure, so a
// test can drive every case without rendering the shell.

import type { LeagueSource } from '../data/leagueSource';

/**
 * The sim clock drives the tutorial and a demo league. It has nothing to say
 * on the hub of a real account, nor inside a real league.
 */
export function showSimClock(
  tutorial: boolean,
  leagueMode: boolean,
  source: LeagueSource,
): boolean {
  if (tutorial) return true;
  return leagueMode && source === 'sim';
}

/**
 * The chat chip and the rail's Chat button, in any league: a practice league's
 * chat is the simulator's, a real league's is served (PLAN-2026-09-26-chat),
 * and the drawer reads whichever the URL names (`data/chat.ts`). Until the hub
 * says which, the chip waits rather than open a drawer that cannot yet know.
 */
export function showLeagueChat(leagueMode: boolean, source: LeagueSource): boolean {
  return leagueMode && source !== 'undecided';
}
